'use es6';

export default Object.freeze(['definition_id', 'smart_objects', 'smart_type']);